import { MultiselectCommand } from '../../core/model/command';
import { RentalObjectCategory } from '../model/const/enums';

export const feeChangeCommand = {
  revert: 'revert',
};
